import { IUser } from '~/models';
import { selectedOfficeApi } from './selectedOfficeApi';

async function getSelectedOffice(officeId: string): Promise<IUser> {
  const selectedOfficeAPI = await selectedOfficeApi.getSelectedOffice(officeId);

  return selectedOfficeAPI;
}

export const selectedOfficeService = {
  getSelectedOffice,
};
